module.exports = __webpack_public_path__ + "static/result_yeouido-e66cd2af3dde046c66d9237305cb6a32.png";